import { t } from '@lingui/macro';
import { Stack } from '@mantine/core';

import { DescriptionList } from '../../components/description-list/description-list';
import { UiCard } from '../../components/ui/ui-card/ui-card';
import { getNameLocal } from '../../lib/local/get-title';
import { useLocal } from '../../lib/local/use-local';
import { CreatedPayment, Station } from './types';

type PayConfirmProps = {
  payment: CreatedPayment;
  stations: { startStation?: Station; endStation?: Station };
};

export const PayConfirm = ({ payment, stations }: PayConfirmProps) => {
  const [lang] = useLocal();
  return (
    <Stack spacing="sm">
      <UiCard>
        <DescriptionList
          list={[
            { label: t`Номер платежа`, value: `# ${payment.id}` },
            { label: t`Дата`, value: new Date(payment.date).toLocaleString() },
            { label: t`Описание`, value: payment.description },
            {
              label: t`Маршрут`,
              value: `${getNameLocal(
                lang,
                stations.startStation
              )} - ${getNameLocal(lang, stations.endStation)}`,
            },
          ]}
        />
      </UiCard>
    </Stack>
  );
};
